import { CaseStudy } from '../../types';

export const teematesTours: CaseStudy = {
  id: 'teemates-tours',
  title: 'TeeMates Tours',
  category: 'Golf Tour Management',
  imageUrl: 'https://images.unsplash.com/photo-1592919505780-303950717480?q=80&w=1200&auto=format&fit=crop',
  description: "The ultimate platform for amateur and professional golf tours. TeeMates Tours completely transforms how golf tours and large tournaments are organized, featuring automated live leaderboards, multi-round scoring, comprehensive player stats, and real-time event updates that keep competitors and fans engaged.",
  screenshots: [
    'https://images.unsplash.com/photo-1593111774640-7adefa3114f0?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?q=80&w=800&auto=format&fit=crop'
  ],
  hasPrivacyPolicy: true,
  hasAccountDeletion: true
};
